import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Home, Users, FileText, User } from 'lucide-react'

interface BottomNavProps {
  activeTab: 'home' | 'passengers' | 'reports' | 'profile'
}

const BottomNav: React.FC<BottomNavProps> = ({ activeTab }) => {
  const navigate = useNavigate()

  const tabs = [
    { id: 'home' as const, label: 'Home', icon: Home, path: '/' },
    { id: 'passengers' as const, label: 'Passengers', icon: Users, path: '/passengers' },
    { id: 'reports' as const, label: 'Reports', icon: FileText, path: '/reports' },
    { id: 'profile' as const, label: 'Profile', icon: User, path: '/profile' },
  ]

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 safe-bottom">
      <div className="flex items-center justify-around py-2">
        {tabs.map(tab => {
          const isActive = activeTab === tab.id
          return (
            <button
              key={tab.id}
              onClick={() => navigate(tab.path)}
              className={`flex flex-col items-center gap-1 py-2 px-4 rounded-lg transition-colors ${
                isActive
                  ? 'text-primary-500'
                  : 'text-gray-500'
              }`}
            >
              <tab.icon size={20} />
              <span className="text-xs font-medium">{tab.label}</span>
            </button>
          )
        })}
      </div>
    </nav>
  )
}

export default BottomNav
